import axios from 'axios';

export default axios.create({
  baseURL: "https://api.dartpos.com",
  headers: {
    'Content-Type': 'application/json'
  }
});
